<template>
  <div class="main_menu">
    <div class="menu_content">
      <img class="top-bar" src="../assets/images/menu_top_bar.png"/>
      <img class="left-top-bar" src="../assets/images/menu_left_bar.png"/>
      <ul ref="menuNode">
        <li v-for="(node,index) in menuData" :data-lesson="node.lesson" :key="index" @click="showSubMenu(index)" :class="node.menuClass==undefined?'hide processing':node.menuClass">
          <router-link  :to="'/section'+(index+1)">{{ index + 1 + '. ' + node.title }}</router-link>
          <ul class="sub_menu" :class="node.isShow!==false?'':'hide'">
            <li @click="clickLink" v-for="(subNode,subIndex) in node.children" :key="index+'-'+subIndex"
                :class="$route.name === subNode.section?'active':''">
              <router-link :class="subNode.isCompleted?'completed':''" :to="subNode.href" v-html="subNode.title"></router-link>
            </li>
          </ul>
          <div class="percent">
            <el-progress type="circle" :stroke-width="3" :width="24" :show-text="false" color="#D41F32" :percentage="node.percent/1*100"></el-progress>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "mainMenu",
  data() {
    return {
      menuData: [
        {
          title: "Introduction and pre-activity quiz",
          lesson: 'lesson1',
          isShow: false,
          percent: 0,
          children: [
            {
              title: "Pre-activity quiz Q1",
              section: "section1-1",
              href: "/section1/1-1",
              isCompleted:false,
            },
            {
              title: "Pre-activity quiz Q2",
              section: "section1-2",
              href: "/section1/1-2",
              isCompleted:false,
            },
            {
              title: "Pre-activity quiz Q3",
              section: "section1-3",
              href: "/section1/1-3",
              isCompleted:false,
            },
            {
              title: "Pre-activity quiz Q4",
              section: "section1-4",
              href: "/section1/1-4",
              isCompleted:false,
            },
            {
              title: "Pre-activity quiz Q5",
              section: "section1-5",
              href: "/section1/1-5",
              isCompleted:false,
            },
            {
              title: "Learning objectives",
              section: "section1-6",
              href: "/section1/1-6",
              isCompleted:false,
            },

          ]
        },
        {
          title: "The role for kidney health monitoring in T2D",
          lesson: 'lesson2',
          isShow: false,
          percent: 0,
          children: [
            {
              title: "Kidney function monitoring and management is a fundamental but frequently neglected part of diabetes care in Australia1–3",
              section: "section2-1",
              href: "/section2/2-1",
              isCompleted:false,
            },
            {
              title: "CV mortality risk is elevated in patients with T2D and CKD1",
              section: "section2-2",
              href: "/section2/2-2",
              isCompleted:false,
            },
            {
              title: "Persistent albuminuria (UACR) is associated with greater CV risk and renal risk in patients with T2D and CKD1,2",
              section: "section2-3",
              href: "/section2/2-3",
              isCompleted:false,
            },
            {
              title: "Regular measurement of UACR and eGFR is necessary to manage patients with T2D, with or without CKD1-7",
              section: "section2-4",
              href: "/section2/2-4",
              isCompleted:false,
            },
            {
              title: "The role for regular measurement of UACR and eGFR: Early assessment is critical because CKD is largely asymptomatic until advanced1",
              section: "section2-5",
              href: "/section2/2-5",
              isCompleted:false,
            }
          ]
        },
        {
          title: "Clinical evidence for nonsteroidal MRAs (finerenone) in reducing kidney progression and CV risks in CKD with T2D",
          lesson: 'lesson3',
          isShow: false,
          percent: 0,
          children: [
            {
              title: "How does the nonsteroidal MRA, finerenone, work?",
              section: "section3-1",
              href: "/section3/3-1",
              isCompleted:false,
            },
            {
              title: "How does the nonsteroidal MRA, finerenone, work?",
              section: "section3-2",
              href: "/section3/3-2",
              isCompleted:false,
            },
            {
              title: "What patients are appropriate for nonsteroidal MRAs treatment with finerenone?",
              section: "section3-3",
              href: "/section3/3-3",
              isCompleted:false,
            },
            {
              title: "FIDELIO-DKD and FIGARO-DKD assessed prespecified kidney outcomes in patients across the spectrum of CKD severity",
              section: "section3-4",
              href: "/section3/3-4",
              isCompleted:false,
            },
            {
              title: "FIDELIO-DKD and FIGARO-DKD assessed prespecified kidney outcomes in patients across the spectrum of CKD severity",
              section: "section3-5",
              href: "/section3/3-5",
              isCompleted:false,
            },
            {
              title: "FIGARO-DKD and FIDELIO-DKD investigated the effects of finerenone on kidney and CV outcomes in over 13,000 patients with CKD and T2D",
              section: "section3-6",
              href: "/section3/3-6",
              isCompleted:false,
            },
            {
              title: "Finerenone safety profile in Phase III trials",
              section: "section3-7",
              href: "/section3/3-7",
              isCompleted:false,
            },
            {
              title: "What do the Phase III studies say about finerenone and hyperkalaemia?",
              section: "section3-8",
              href: "/section3/3-8",
              isCompleted:false,
            },
            {
              title: "In FIDELITY, finerenone reduced UACR by 32% between baseline and month 4 versus placebo",
              section: "section3-9",
              href: "/section3/3-9",
              isCompleted:false,
            },
            {
              title: "Finerenone reduced the risk of the CV and kidney composite outcome",
              section: "section3-10",
              href: "/section3/3-10",
              isCompleted:false,
            },
            {
              title: "CONFIDENCE investigated the combination of finerenone and SGLT2i in persons with chronic kidney disease and type 2 diabetes",
              section: "section3-11",
              href: "/section3/3-11",
              isCompleted:false,
            },
            {
              title: "CONFIDENCE investigated the combination of finerenone and SGLT2i in persons with chronic kidney disease and type 2 diabetes",
              section: "section3-12",
              href: "/section3/3-12",
              isCompleted:false,
            },
            {
              title: "CONFIDENCE investigated the combination of finerenone and SGLT2i in persons with chronic kidney disease and type 2 diabete",
              section: "section3-13",
              href: "/section3/3-13",
              isCompleted:false,
            }
          ]
        },
        {
          title: "Initiating nonsteroidal MRAs (finerenone) in clinical practice as part of a comprehensive approach to CKD associated with T2D",
          lesson: 'lesson4',
          isShow: false,
          percent: 0,
          children: [
            {
              title: "People with diabetes and chronic kidney disease (CKD) should be treated with a comprehensive approach to improve kidney and cardiovascular outcomes: KDIGO 2022",
              section: "section4-1",
              href: "/section4/4-1",
              isCompleted:false,
            },
            {
              title: "International and local guidelines are now in consensus about the role of nonsteroidal MRAs (finerenone) for patients with in T2D and CKD",
              section: "section4-2",
              href: "/section4/4-2",
              isCompleted:false,
            },
            {
              title: "Recent clinical guidelines for the management of CKD in patients with T2D recommend a combination of drug therapies to optimally reduce risks",
              section: "section4-3",
              href: "/section4/4-3",
              isCompleted:false,
            },
            {
              title: "ESC 2023 guideline recommendations for treatment of patients with T2D and CKD",
              section: "section4-4",
              href: "/section4/4-4",
              isCompleted:false,
            },
            {
              title: "Which of your patients would be eligible for nonsteroidal MRAs (finerenone)?",
              section: "section4-5",
              href: "/section4/4-5",
              isCompleted:false,
            },
            {
              title: "Impact on eGFR after initiation of finerenone",
              section: "section4-6",
              href: "/section4/4-6",
              isCompleted:false,
            },
            {
              title: "Prescribing considerations for finerenone",
              section: "section4-7",
              href: "/section4/4-7",
              isCompleted:false,
            },
            {
              title: "Initiation, dosing and titration",
              section: "section4-8",
              href: "/section4/4-8",
              isCompleted:false,
            },
            {
              title: "Closing thoughts",
              section: "section4-9",
              href: "/section4/4-9",
              isCompleted:false,
            }
          ]
        },
        {
          title: "Post-activity quiz",
          lesson: 'lesson5',
          isShow: false,
          percent: 0,
          children: [
            {
              title: "Post-activity quiz",
              section: "section5-1",
              href: "/section5/5-1",
              isCompleted:false,
            },
            {
              title: "Post-activity quiz",
              section: "section5-2",
              href: "/section5/5-2",
              isCompleted:false,
            },
            {
              title: "Post-activity quiz",
              section: "section5-3",
              href: "/section5/5-3",
              isCompleted:false,
            },
            {
              title: "Post-activity quiz",
              section: "section5-4",
              href: "/section5/5-4",
              isCompleted:false,
            },
            {
              title: "Post-activity quiz",
              section: "section5-5",
              href: "/section5/5-5",
              isCompleted:false,
            },
            {
              title: "Module completed",
              section: "section5-6",
              href: "/section5/5-6",
              isCompleted:false,
            }


          ]
        }
      ],
      clickMenu: false,
    }
  },
  mounted() {
    this.expand();
    this.progress();

  },
  updated() {
    this.expand();
    this.progress();
  },
  methods: {
    showSubMenu(index) {
      this.clickMenu = true;
      if (this.menuData[index].isShow === false) {
        this.menuData.forEach(function (node, index) {
          node.isShow = false
        });
        this.menuData[index].isShow = true;
      } else {

        this.menuData[index].isShow = false;
      }
      this.expand();
      this.progress();

    },
    expand() {
      let _this = this;

      if (_this.clickMenu === false) {
        this.menuData.forEach(function (node, index) {
          //菜单展示
          if (node.lesson === _this.$route.meta.lesson) {
            node.isShow = true;
          } else {
            node.isShow = false;
          }

        });
        _this.clickMenu = false;

      }
    },
    clickLink(e) {
      e.stopPropagation();
    },
    progress(){
      //完成度计算
      let lessonInfo = this.tool.getLocalData('lessonInfo');
      let _this = this;

      this.menuData.forEach(function (node, index) {
        if(lessonInfo !== null && lessonInfo!==undefined){
          lessonInfo.forEach(function(lesson,lessonIndex){
            let percent = 0;
            lesson.sections.forEach(function(section,sectionIndex){ //计算总完成百分比
              if(section.percent && (typeof section.percent === 'number')) {
                percent = percent + section.percent*1;
              }
            });
            if(node.lesson == lesson.lesson ){
              node.percent = percent.toFixed(2);

              //单科课程完成情况
              lesson.sections.forEach(function(section,sectionIndex){
                node.children.forEach(function(subNode,subIndex){
                  //if('section'+(subNode.section.substr(subNode.section.length-1))==section.section){
                  let sectionArrays = subNode.section.split("-");
                  if('section'+(sectionArrays[1])==section.section){
                    subNode.isCompleted = true;
                  }
                });
              });



            }
          });
        }

        //遍历menu数据展开状态

        let menuClass = '';

        if(node.isShow===false){
          menuClass +='hide ';
        }
        if(node.percent*1 === 1){
          menuClass += 'completed';
        }else{
          menuClass += 'processing';
        }
        node.menuClass = menuClass;
      });

      //计算子菜单高度

      this.$refs.menuNode.childNodes.forEach(function(node,index){
        let cc = node.getAttribute('class');
        // if(cc!==null){
        //   console.log(cc.indexOf('hide'));
        //   if(node.getAttribute('data-lesson')!==_this.$route.meta.lesson && cc.indexOf('hide')===-1){
        //     node.setAttribute('class',node.getAttribute('class')+' hide');
        //   }else{
        //     node.setAttribute('class',node.getAttribute('class').replace('hide',''));
        //   }
        // }


        if(node.getElementsByTagName('ul')[0].getAttribute('class').indexOf('hide')===-1){
          let height = 0;
          node.getElementsByTagName('ul')[0].childNodes.forEach(function(liNode,liIndex){
            height += liNode.offsetHeight +12;
          });
          node.getElementsByTagName('ul')[0].setAttribute('style','height:'+height+'px');
        }
      });

    }
  }
}
</script>

<style scoped>

</style>
